import React, { CSSProperties, ReactNode } from "react";

import {
  useRouterContext,
  useLink,
  useRouterType,
  useRefineOptions,
} from "@refinedev/core";

import MuiLink from "@mui/material/Link";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

interface SyncrosaleThemedTitleProps {
  collapsed?: boolean;
  wrapperStyles?: CSSProperties;
  icon?: ReactNode | string;
  text?: ReactNode;
}

export const SyncrosaleThemedTitle: React.FC<SyncrosaleThemedTitleProps> = ({
  collapsed,
  wrapperStyles,
  icon: iconFromProps,
  text: textFromProps,
}) => {
  const { title: { icon: defaultIcon, text: defaultText } = {} } =
    useRefineOptions();

  const icon = iconFromProps === undefined ? defaultIcon : iconFromProps;
  const text = textFromProps === undefined ? defaultText : textFromProps;

  const routerType = useRouterType();
  const Link = useLink();
  const { Link: LegacyLink } = useRouterContext();

  const ActiveLink = routerType === "legacy" ? LegacyLink : Link;

  return (
    <MuiLink
      to="/"
      component={ActiveLink}
      underline="none"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        textDecoration: "none",
        "&:hover": {
          textDecoration: "none !important",
        },
        ...wrapperStyles,
      }}
    >
      {typeof icon === "string" ? (
        <Box
          sx={{ position: "relative", width: 48, height: 48, flexShrink: 0 }}
        >
          <img
            src={icon}
            alt="logo"
            style={{
              width: 48,
              height: 48,
              objectFit: "contain",
              transition: "transform 5s ease",
            }}
          />
        </Box>
      ) : (
        <SvgIcon
          height="24px"
          width="24px"
          color="primary"
          sx={{ fontSize: "24px" }}
        >
          {icon}
        </SvgIcon>
      )}
      {!collapsed && (
        <Typography
          variant="h6"
          fontWeight={700}
          color="text.primary"
          fontSize="inherit"
          textOverflow="ellipsis"
          overflow="hidden"
        >
          {text}
        </Typography>
      )}
    </MuiLink>
  );
};
